import classNames from 'classnames';
import { ReactNode } from 'react';

// xs: '0.05em',
//   sm: '0.1em',
// default: '0.2em',
//   lg: '0.4em',
//   xl: '0.8em',

export enum NeumorphType {
  None = 'none',
  Hoverable = 'hoverable',
  HoverableInset = 'hoverable-inset',
}

const neumorphClasses: { [key in NeumorphType]: string[] } = {
  [NeumorphType.None]: ['nm-flat-gray-100'],
  [NeumorphType.Hoverable]: [
    'cursor-pointer',
    'nm-flat-gray-100',
    'hover:nm-concave-gray-100',
    'active:nm-inset-gray-100',
  ],
  [NeumorphType.HoverableInset]: [
    'cursor-pointer',
    'nm-inset-gray-100',
    'hover:nm-flat-gray-100',
    'active:nm-inset-gray-100',
  ],
};

export default function NeumorphBox({
  type = NeumorphType.None,
  className = '',
  children,
  onClick,
  inline,
}: {
  type?: NeumorphType;
  className?: string;
  children?: ReactNode;
  onClick?: () => void;
  inline?: boolean;
}) {
  return (
    <div
      className={classNames(
        'rounded-[0.3em]',
        'm-[1em]',
        children ? 'p-[1em]' : 'h-[3px]',
        neumorphClasses[type],
        inline ? ['inline-block', 'px-[2em]'] : undefined,
        className
      )}
      onClick={onClick ?? (() => {})}
    >
      {children}
    </div>
  );
}
